import GetCalculationDependencies from '../calculationDependencies';
import isFieldMissing from './IsFieldMissing';

function updateCalculations(inputs, options, result) {
  if (options.length === 0) {
    return null;
  }
  let newCalculations = [];

  const calculationDependencies = GetCalculationDependencies(inputs);
  calculationDependencies.forEach((condition) => {
    const allConditionsMet = condition.conditions.every((inputName) => {
      if (!inputs[inputName]) return;
      return !isFieldMissing(inputName, options, inputs, result, 'all', true);
    });

    if (condition.validation) {
      const allValidationsMet = Object.keys(condition.validation).every(
        (validationKey) => {
          const validationValue = condition.validation[validationKey];
          return inputs[validationKey] === validationValue;
        }
      );

      if (allConditionsMet && allValidationsMet) {
        condition.calculation.forEach((calc) => {
          if (!newCalculations.includes(calc)) {
            newCalculations.push(calc);
          }
        });
      }
    } else {
      if (allConditionsMet) {
        condition.calculation.forEach((calc) => {
          if (!newCalculations.includes(calc)) {
            newCalculations.push(calc);
          }
        });
      }
    }
  });

  return newCalculations;
}

export default updateCalculations;
